<template>
    <div class="container">
        <!-- 顶部搜索栏 -->
        <div class="search" style="display: flex">
            <el-form ref="formRef" style="flex: 1" :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="设备UUID：">
                    <el-input v-model.trim="searchForm.uuid" placeholder="请输入设备UUID" clearable size="small"
                        @keyup.enter="handleTopSearch" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="区域：">
                    <el-select v-model="searchForm.region" placeholder="请选择区域" size="small" style="width: 180px">
                        <el-option label="美洲" value="us"></el-option>
                        <el-option label="欧洲" value="eu"></el-option>
                        <el-option label="中国" value="cn"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" :loading="loading.deviceDetail"
                        @click="handleTopSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- Tab栏 -->
        <el-tabs v-model="activeTab">
            <!-- 设备信息 -->
            <el-tab-pane label="设备信息" name="deviceInfo">
                <div v-if="deviceDetail" v-loading="loading.deviceDetail">
                    <el-card>
                        <template #header>
                            <div class="card-header"><span>设备基础信息</span></div>
                        </template>
                        <div class="detail-info">
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">设备UUID</span>
                                    <span class="detail-value">{{ deviceDetail.device?.uuid }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">设备业务ID</span>
                                    <span class="detail-value">{{ deviceDetail.device?.device_id }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">父级设备UUID</span>
                                    <span class="detail-value">{{ deviceDetail.device?.p_uuid || '无' }}</span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">产品型号</span>
                                    <span class="detail-value">{{ deviceDetail.device?.model_code }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">设备名称</span>
                                    <span class="detail-value">{{ deviceDetail.device?.name }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">WIFI强度</span>
                                    <span class="detail-value">{{ deviceDetail.device?.wifi_level }}</span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">国家码</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.country || '无' }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">时区</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.zone }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">电量值</span>
                                    <span class="detail-value">{{ deviceDetail.device?.battery_level }}%</span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">充电状态</span>
                                    <span class="detail-value">
                                        <el-tag
                                            :type="getBatteryOnlineTagType(deviceDetail.device?.online_type, deviceDetail.device?.battery_online)">
                                            {{ getBatteryOnlineText(deviceDetail.device?.online_type,
                                                deviceDetail.device?.battery_online) }}
                                        </el-tag>
                                    </span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">休眠状态</span>
                                    <span class="detail-value">
                                        <el-tag :type="deviceDetail.device?.open_status === 1 ? 'success' : 'danger'">
                                            {{ openStatusMap[deviceDetail.device?.open_status] || '未知' }}
                                        </el-tag>
                                    </span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">在线类型</span>
                                    <span class="detail-value">
                                        <el-tag>{{ onlineTypeMap[deviceDetail.device?.online_type] || '未知' }}</el-tag>
                                    </span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">MQTT在线状态</span>
                                    <span class="detail-value">
                                        <el-tag :type="deviceDetail.device?.mq_online === 1 ? 'success' : 'danger'">
                                            {{ mqOnlineMap[deviceDetail.device?.mq_online] || '未知' }}
                                        </el-tag>
                                    </span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">P2P在线状态</span>
                                    <span class="detail-value">
                                        <el-tag :type="deviceDetail.device?.p2p_online === 1 ? 'success' : 'danger'">
                                            {{ p2pOnlineMap[deviceDetail.device?.p2p_online] || '未知' }}
                                        </el-tag>
                                    </span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">P2P地址</span>
                                    <span class="detail-value">{{ deviceDetail.device?.p2p_domain || '无' }}</span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">P2P IP地址</span>
                                    <span class="detail-value">{{ formatIpAddress(deviceDetail.device?.p2p_ip) }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">P2P端口</span>
                                    <span class="detail-value">{{ deviceDetail.device?.p2p_port || '无' }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">品牌</span>
                                    <span class="detail-value">{{ deviceDetail.device?.brand }}</span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">兼容版本控制位</span>
                                    <span class="detail-value">{{ deviceDetail.device?.ver_control || '无' }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">照明灯泡状态</span>
                                    <span class="detail-value">
                                        <el-tag :type="deviceDetail.device?.lighting_status === 1 ? 'success' : 'info'">
                                            {{ deviceDetail.device?.lighting_status === 1 ? '已开启' : '已关闭' }}
                                        </el-tag>
                                    </span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">最近一次上线时间</span>
                                    <span class="detail-value">{{
                                        formatMillisTimestamp(deviceDetail.device?.online_time) }}</span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">最近一次离线时间</span>
                                    <span class="detail-value">{{
                                        formatMillisTimestamp(deviceDetail.device?.offline_time) }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">最近一次激活绑定时间</span>
                                    <span class="detail-value">{{ formatTimestamp(deviceDetail.device?.create_time)
                                        }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">最近一次数据修改时间</span>
                                    <span class="detail-value">{{ formatTimestamp(deviceDetail.device?.update_time)
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </el-card>

                    <el-card style="margin-top: 16px">
                        <template #header>
                            <div class="card-header"><span>设备配置信息</span></div>
                        </template>
                        <div class="detail-info">
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">SN编号</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.sn || '无' }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">MAC地址</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.mac }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">固件版本</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.version }}</span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">产品型号</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.model }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">本地IP</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.local_ip_str }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">外网IP</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.network_ip_str }}</span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">区域</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.region }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">设备配置</span>
                                    <span class="detail-value">
                                        <span v-if="!deviceDetail.device_info?.device_config">无</span>
                                        <span v-else-if="isValidJSON(deviceDetail.device_info.device_config)">
                                            <el-popover placement="top" width="500" trigger="click">
                                                <template #reference><el-button size="small"
                                                        type="text">查看详情</el-button></template>
                                                <pre
                                                    class="json-pre">{{ formatJSON(deviceDetail.device_info.device_config) }}</pre>
                                            </el-popover>
                                        </span>
                                        <span v-else>{{ deviceDetail.device_info.device_config }}</span>
                                    </span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">APP配置</span>
                                    <span class="detail-value">
                                        <span v-if="!deviceDetail.device_info?.app_config">无</span>
                                        <span v-else-if="isValidJSON(deviceDetail.device_info.app_config)">
                                            <el-popover placement="top" width="500" trigger="click">
                                                <template #reference><el-button size="small"
                                                        type="text">查看详情</el-button></template>
                                                <pre
                                                    class="json-pre">{{ formatJSON(deviceDetail.device_info.app_config) }}</pre>
                                            </el-popover>
                                        </span>
                                        <span v-else>{{ deviceDetail.device_info.app_config }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">流媒体配置</span>
                                    <span class="detail-value">
                                        <span v-if="!deviceDetail.device_info?.flow_config">无</span>
                                        <span v-else-if="isValidJSON(deviceDetail.device_info.flow_config)">
                                            <el-popover placement="top" width="500" trigger="click">
                                                <template #reference><el-button size="small"
                                                        type="text">查看详情</el-button></template>
                                                <pre
                                                    class="json-pre">{{ formatJSON(deviceDetail.device_info.flow_config) }}</pre>
                                            </el-popover>
                                        </span>
                                        <span v-else>{{ deviceDetail.device_info.flow_config }}</span>
                                    </span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">设备防盗开启状态</span>
                                    <span class="detail-value">
                                        <el-tag
                                            :type="deviceDetail.device_info?.theft_status === 2 ? 'warning' : 'success'">
                                            {{ deviceDetail.device_info?.theft_status === 2 ? '开启' : '关闭' }}
                                        </el-tag>
                                    </span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">设备所属产品唯一标识码</span>
                                    <span class="detail-value">{{ deviceDetail.device_info?.pid }}</span>
                                </div>
                            </div>
                            <div class="detail-row">
                                <div class="detail-item">
                                    <span class="detail-label">数据创建时间</span>
                                    <span class="detail-value">{{ formatTimestamp(deviceDetail.device_info?.create_time)
                                    }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">设备数据最后一次更新时间</span>
                                    <span class="detail-value">{{ formatTimestamp(deviceDetail.device_info?.update_time)
                                    }}</span>
                                </div>
                                <div class="detail-item"></div>
                            </div>
                        </div>
                    </el-card>

                    <el-card v-if="isSimdataModel(deviceDetail.device)" style="margin-top: 16px"
                        v-loading="netInfoLoading">
                        <template #header>
                            <div class="card-header">
                                <span>4G设备网络情况</span>
                                <el-button type="primary" size="small" @click="updateNetInfo" text>更新网络配置</el-button>
                            </div>
                        </template>
                        <el-form :inline="true" label-width="140px" label-position="right">
                            <el-row>
                                <el-col>
                                    <el-form-item label="IMEI">
                                        <el-input disabled v-model="netInfoImei"></el-input>
                                    </el-form-item>
                                    <el-form-item label="事务ID">
                                        <el-input disabled v-model="netInfo.trans_id"></el-input>
                                    </el-form-item>
                                    <el-form-item label="更新时间">
                                        <el-input disabled v-model="netInfo.sync_time"></el-input>
                                    </el-form-item>
                                    <el-form-item label="信号">
                                        <el-input disabled v-model="netInfo.signal"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-form-item label="当前PLMN">
                                        <el-input disabled v-model="netInfo.curr_plmn"></el-input>
                                    </el-form-item>
                                    <el-form-item label="前一个PLMN">
                                        <el-input disabled v-model="netInfo.prev_plmn"></el-input>
                                    </el-form-item>
                                    <el-form-item label="当前卡IMSI">
                                        <el-input disabled v-model="netInfo.card_imsi"></el-input>
                                    </el-form-item>
                                    <el-form-item label="当前卡供应商">
                                        <el-input disabled v-model="netInfo.card_vendor"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-form-item label="套餐record id">
                                        <el-input disabled v-model="netInfo.precord_id"></el-input>
                                    </el-form-item>
                                    <el-form-item label="套餐item id">
                                        <el-input disabled v-model="netInfo.pitem_id"></el-input>
                                    </el-form-item>
                                    <el-form-item label="套餐配置PLMN">
                                        <el-input v-model="netInfo.cfg_oplmn" placeholder="可手动输入"></el-input>
                                    </el-form-item>
                                    <el-form-item label="套餐配置供应商">
                                        <el-select v-model="netInfo.cfg_vendor" clearable placeholder="请选择供应商">
                                            <el-option v-for="item in netInfo.vendor_list" :key="item.id"
                                                :label="item.name" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <h4>可选供应商列表</h4>
                        <el-table border :data="netInfo.vendor_list" size="small">
                            <el-table-column label="供应商ID" prop="id"></el-table-column>
                            <el-table-column label="供应商名称" prop="name"></el-table-column>
                            <el-table-column label="优先级" prop="prio"></el-table-column>
                        </el-table>
                    </el-card>
                </div>
                <el-empty v-else description="请输入设备UUID进行查询" />
            </el-tab-pane>

            <!-- 设备与用户绑定关系 -->
            <el-tab-pane label="设备与用户绑定关系" name="deviceUsers">
                <el-card v-loading="loading.deviceDetail">
                    <template #header>
                        <div class="card-header"><span>设备与用户绑定关系</span></div>
                    </template>
                    <el-table v-if="deviceUsers.length > 0" border :data="deviceUsers" size="small">
                        <el-table-column label="用户UID" width="200">
                            <template v-slot="{ row }">
                                <span style="color: #409eff; cursor: pointer" @click="viewUserDetail(row)">{{ row.uid
                                    }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="绑定类型">
                            <template v-slot="{ row }">{{ { 1: '主人', 2: '分享' }[row.bind_type] || '未知' }}</template>
                        </el-table-column>
                        <el-table-column label="设备类型">
                            <template v-slot="{ row }">{{ { 1: '一级设备', 2: '二级设备' }[row.device_type] || '未知'
                                }}</template>
                        </el-table-column>
                        <el-table-column label="试用状态">
                            <template v-slot="{ row }">{{ { 0: '未使用', 1: '已使用' }[row.trial_status] || '未知' }}</template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template v-slot="{ row }">
                                <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
                                    {{ row.status === 1 ? '绑定' : '解绑' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="首次绑定时间" width="160">
                            <template v-slot="{ row }">{{ formatTimestamp(row.first_time) }}</template>
                        </el-table-column>
                        <el-table-column label="绑定时间" width="160">
                            <template v-slot="{ row }">{{ formatTimestamp(row.bind_time) }}</template>
                        </el-table-column>
                        <el-table-column label="解绑时间" width="160">
                            <template v-slot="{ row }">{{ row.delete_time ? formatTimestamp(row.delete_time) : '未解绑'
                                }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="220" fixed="right">
                            <template v-slot="{ row }">
                                <el-button size="mini" type="primary" @click="viewCloudStorage(row)">云存储</el-button>
                                <el-button
                                    v-if="deviceDetail && deviceDetail.device && (deviceDetail.device.online_type === 1 || isHuntingDevice(deviceDetail.device)) && row.bind_type == 1"
                                    size="mini" type="success" @click="viewDeviceShadow(row)">设备影子</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-empty v-else description="暂无绑定关系数据" />
                </el-card>
            </el-tab-pane>

            <!-- 设备日志 -->
            <el-tab-pane label="设备日志" name="deviceLogs">
                <el-card>
                    <template #header>
                        <div class="card-header"><span>设备日志</span></div>
                    </template>
                    <el-form :inline="true" :model="deviceLogsForm" style="margin-bottom: 16px">
                        <el-form-item label="属性/事件：">
                            <el-select v-model="deviceLogsForm.identifier" placeholder="请选择属性/事件" clearable filterable
                                size="small" style="width: 200px">
                                <el-option v-for="item in deviceLogsTypes" :key="item.key" :label="item.value"
                                    :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用户UID：">
                            <el-input v-model="deviceLogsForm.uid" placeholder="请输入用户UID" clearable size="small"
                                style="width: 200px"></el-input>
                        </el-form-item>
                        <el-form-item label="开始时间：">
                            <el-date-picker v-model="deviceLogsForm.start_time" type="datetime" placeholder="选择开始时间"
                                format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" size="small"
                                style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间：">
                            <el-date-picker v-model="deviceLogsForm.end_time" type="datetime" placeholder="选择结束时间"
                                format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" size="small"
                                style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" :loading="loading.deviceLogs"
                                @click="searchDeviceLogs">查询</el-button>
                            <el-button size="small" @click="resetDeviceLogsForm">重置</el-button>
                        </el-form-item>
                    </el-form>

                    <el-table v-loading="loading.deviceLogs" border :data="deviceLogsList" size="small">
                        <el-table-column label="属性/事件" prop="identifier" width="120"></el-table-column>
                        <el-table-column label="描述" prop="description" width="120"></el-table-column>
                        <el-table-column label="产品型号" prop="product_key" width="160"></el-table-column>
                        <el-table-column label="MQTT上报类型" prop="action_type" width="160"></el-table-column>
                        <el-table-column label="用户UID" prop="uid" width="140"></el-table-column>
                        <el-table-column label="消息ID" prop="message_id"></el-table-column>
                        <el-table-column label="消息来源" prop="source_type" width="100"></el-table-column>
                        <el-table-column label="IP地址" prop="ip" width="120"></el-table-column>
                        <el-table-column label="值" prop="value">
                            <template v-slot="{ row }">
                                <span v-if="!row.value">-</span>
                                <span v-else-if="isValidJSON(row.value)">
                                    <el-popover placement="top" width="500" trigger="click">
                                        <template #reference><el-button size="small"
                                                type="text">查看详情</el-button></template>
                                        <pre class="json-pre">{{ formatJSON(row.value) }}</pre>
                                    </el-popover>
                                </span>
                                <span v-else
                                    style="display: block; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
                                    :title="row.value">{{ row.value }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" prop="created_at" width="160"></el-table-column>
                    </el-table>

                    <el-pagination @current-change="handleDeviceLogsPageChange"
                        @size-change="handleDeviceLogsSizeChange" v-model:currentPage="deviceLogsPagination.currentPage"
                        :page-size="deviceLogsPagination.pageSize" :page-sizes="[15, 30, 50, 100]"
                        layout="total, sizes, prev, pager, next" :total="deviceLogsPagination.total" background
                        style="margin-top: 16px; justify-content: flex-end">
                    </el-pagination>
                </el-card>
            </el-tab-pane>

            <!-- 设备消息 -->
            <el-tab-pane label="设备消息" name="deviceMessage">
                <el-card>
                    <template #header>
                        <div class="card-header">
                            <span>设备消息</span>
                            <template v-if="searchForm.uuid">
                                <el-link v-show="!deviceMessageChartHidden" type="primary" :underline="false"
                                    class="device-msg-histogram__link-sm"
                                    @click.prevent="deviceMessageChartHidden = true">隐藏图表</el-link>
                                <el-link v-show="deviceMessageChartHidden" type="primary" :underline="false"
                                    class="device-msg-histogram__link-sm"
                                    @click.prevent="deviceMessageChartHidden = false">显示图表</el-link>
                            </template>
                        </div>
                    </template>
                    <!-- 每日消息量（接口：device_message_daily_summary，仅传 uuid）；隐藏时不占位 -->
                    <div v-if="searchForm.uuid && !deviceMessageChartHidden" class="device-msg-histogram">
                        <div class="device-msg-histogram__toolbar">
                            <div class="device-msg-histogram__toolbar-main">
                                <span class="device-msg-histogram__hits">{{ deviceMessageDailyHitsText }}</span>
                                <span v-if="deviceMessageDailyRangeText" class="device-msg-histogram__range">{{
                                    deviceMessageDailyRangeText }}</span>
                                <span class="device-msg-histogram__granularity">按日</span>
                            </div>
                        </div>
                        <div v-loading="loading.deviceMessageChart" class="device-msg-histogram__chart-wrap">
                            <div id="deviceMessageDailyChart" class="device-msg-histogram__chart"></div>
                        </div>
                    </div>
                    <el-form :inline="true" :model="deviceMessageForm" style="margin-bottom: 16px">
                        <el-form-item label="消息类型：">
                            <el-select v-model="deviceMessageForm.type" placeholder="请选择消息类型" clearable size="small"
                                style="width: 200px">
                                <el-option v-for="item in messageTypeMap" :key="item.key" :label="item.value"
                                    :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开始时间：">
                            <el-date-picker v-model="deviceMessageForm.start_time" type="datetime" placeholder="选择开始时间"
                                format="YYYY-MM-DD HH:mm:ss" value-format="X" size="small"
                                style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间：">
                            <el-date-picker v-model="deviceMessageForm.end_time" type="datetime" placeholder="选择结束时间"
                                format="YYYY-MM-DD HH:mm:ss" value-format="X" size="small"
                                style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" :loading="loading.deviceMessage"
                                @click="searchDeviceMessage()">查询</el-button>
                            <el-button size="small" @click="resetDeviceMessageForm">重置</el-button>
                        </el-form-item>
                    </el-form>

                    <el-table v-loading="loading.deviceMessage" border :data="deviceMessageList" size="small">
                        <el-table-column label="设备名称" prop="device" width="200" show-overflow-tooltip></el-table-column>
                        <el-table-column label="消息类型" width="100">
                            <template v-slot="{ row }">{{ getMessageTypeName(row.type) }}</template>
                        </el-table-column>
                        <el-table-column label="文件路径" prop="files" min-width="300"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="文件存储时间" prop="file_time" width="160"></el-table-column>
                        <el-table-column label="设备上报时间" width="160">
                            <template v-slot="{ row }">{{ formatTimestamp(row.device_time) }}</template>
                        </el-table-column>
                        <el-table-column label="消息时间" width="160">
                            <template v-slot="{ row }">{{ formatTimestamp(row.time) }}</template>
                        </el-table-column>
                        <el-table-column label="是否存在云视频" width="120" align="center">
                            <template v-slot="{ row }">
                                <span v-if="messageCloudVideoStatus[row.id] === 'loading'">
                                    <i class="el-icon-loading"></i>
                                </span>
                                <el-tag v-else-if="messageCloudVideoStatus[row.id] === true" type="success"
                                    size="small">是</el-tag>
                                <el-tag v-else type="info" size="small">否</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 自定义分页控件 (游标分页) -->
                    <div
                        style="display: flex; justify-content: space-between; align-items: center; padding: 16px 0; border-top: 1px solid #ebeef5; margin-top: 16px">
                        <div style="display: flex; align-items: center; font-size: 14px; color: #606266">
                            <span>每页显示</span>
                            <el-select :model-value="deviceMessagePagination.pageSize" size="small"
                                style="width: 80px; margin: 0 8px" @change="handleDeviceMessageSizeChange">
                                <el-option :value="15" label="15"></el-option>
                                <el-option :value="30" label="30"></el-option>
                                <el-option :value="50" label="50"></el-option>
                                <el-option :value="100" label="100"></el-option>
                            </el-select>
                            <span>条</span>
                        </div>
                        <div style="display: flex; gap: 8px">
                            <el-button size="small" :disabled="!deviceMessagePagination.hasPrevPage"
                                @click="handleDeviceMessagePrevPage">上一页</el-button>
                            <el-button size="small" :disabled="!deviceMessagePagination.hasNextPage"
                                @click="handleDeviceMessageNextPage">下一页</el-button>
                        </div>
                    </div>
                </el-card>
            </el-tab-pane>

            <!-- 云视频列表 -->
            <el-tab-pane label="云视频列表" name="cloudVideo">
                <el-card>
                    <template #header>
                        <div class="card-header"><span>云视频列表</span></div>
                    </template>
                    <el-form :inline="true" :model="cloudVideoForm" style="margin-bottom: 16px">
                        <el-form-item label="用户UID：">
                            <el-select v-model="cloudVideoForm.uid" placeholder="请选择用户UID" clearable filterable
                                size="small" style="width: 200px">
                                <el-option v-for="user in deviceUsers" :key="user.uid"
                                    :label="user.uid + ' (' + (user.bind_type === 1 ? '主人' : '分享') + ')'"
                                    :value="user.uid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="日期：">
                            <el-date-picker v-model="cloudVideoForm.file_date" type="date" placeholder="选择日期"
                                format="YYYY-MM-DD" value-format="YYYY-MM-DD" size="small"
                                style="width: 200px"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" :loading="loading.cloudVideo"
                                @click="searchCloudVideoList">查询</el-button>
                            <el-button size="small" @click="resetCloudVideoForm">重置</el-button>
                        </el-form-item>
                    </el-form>

                    <div v-if="cloudVideoList.length > 0" v-loading="loading.cloudVideo">
                        <div class="video-grid">
                            <div v-for="(item, index) in pagedCloudVideoList" :key="index" class="video-card">
                                <div class="video-placeholder">
                                    <el-image src="/placeholder.png" fit="cover" style="width: 100%; height: 100%">
                                        <template #error>
                                            <div
                                                style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background: #f5f7fa; color: #c0c4cc">
                                                <i class="el-icon-picture" style="font-size: 32px"></i>
                                            </div>
                                        </template>
                                    </el-image>
                                </div>
                                <div class="video-info">
                                    <div class="info-row">
                                        <span class="label">开始时间:</span>
                                        <span class="value">{{ formatCloudVideoTime(cloudVideoData.filedate, item.s)
                                        }}</span>
                                    </div>
                                    <div class="info-row">
                                        <span class="label">结束时间:</span>
                                        <span class="value">{{ formatCloudVideoTime(cloudVideoData.filedate, item.s +
                                            item.l) }}</span>
                                    </div>
                                    <div class="info-row">
                                        <span class="label">文件类型:</span>
                                        <span class="value">{{ cloudVideoData.filetype }}</span>
                                    </div>
                                    <div class="info-row">
                                        <span class="label">过期时间:</span>
                                        <span class="value">{{ formatTimestamp(cloudVideoData.expirationtime) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-pagination v-model:currentPage="cloudVideoPagination.currentPage"
                            :page-size="cloudVideoPagination.pageSize" :page-sizes="[12, 24, 48, 96]"
                            :total="cloudVideoPagination.total" layout="total, sizes, prev, pager, next" background
                            style="margin-top: 16px; justify-content: flex-end"
                            @size-change="handleCloudVideoSizeChange" @current-change="handleCloudVideoPageChange">
                        </el-pagination>
                    </div>
                    <el-empty v-else-if="!loading.cloudVideo" description="暂无云视频数据" />
                </el-card>
            </el-tab-pane>

            <!-- 设备属性值统计 -->
            <el-tab-pane label="设备属性值统计" name="identifierValues">
                <el-card>
                    <template #header>
                        <div class="card-header"><span>设备属性值统计</span></div>
                    </template>
                    <el-form :inline="true" :model="identifierValuesForm" style="margin-bottom: 16px">
                        <el-form-item label="属性/事件：">
                            <el-select v-model="identifierValuesForm.identifier" placeholder="请选择属性/事件" clearable
                                filterable size="small" style="width: 200px">
                                <el-option v-for="item in identifierValueTypes" :key="item.key"
                                    :label="item.name || item.value" :value="item.key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用户UID：">
                            <el-input v-model="identifierValuesForm.uid" placeholder="请输入用户UID" clearable size="small"
                                style="width: 200px"></el-input>
                        </el-form-item>
                        <el-form-item label="时间范围：">
                            <el-date-picker v-model="identifierValuesTimeRange" type="datetimerange"
                                start-placeholder="开始时间" end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss"
                                value-format="YYYY-MM-DD HH:mm:ss" size="small" :shortcuts="timeRangeShortcuts">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" :loading="loading.identifierValues"
                                @click="handleIdentifierValuesSearch">查询</el-button>
                            <el-button size="small" @click="handleIdentifierValuesReset">重置</el-button>
                        </el-form-item>
                    </el-form>

                    <!-- 图表 -->
                    <div v-if="identifierValuesChartReady" id="identifierValuesChart"
                        style="width: 100%; height: 450px"></div>
                    <div v-else-if="identifierValuesSearched"
                        style="width: 100%; height: 450px; display: flex; align-items: center; justify-content: center; color: #909399; font-size: 14px">
                        暂无数据
                    </div>

                    <!-- 数据表格 -->
                    <el-table v-if="identifierValuesData.length > 0"
                        :data="identifierValuesData.slice((valuesTablePage - 1) * valuesTablePageSize, valuesTablePage * valuesTablePageSize)"
                        border size="small" max-height="400" style="margin-top: 20px">
                        <el-table-column prop="created_at" label="时间" min-width="180"></el-table-column>
                        <el-table-column prop="device_id" label="设备UUID" min-width="150"></el-table-column>
                        <el-table-column label="属性/事件" min-width="150">
                            <template v-slot="{ row }">{{ getIdentifierLabel(row.identifier) }}</template>
                        </el-table-column>
                        <el-table-column prop="value" label="值" min-width="120"></el-table-column>
                    </el-table>
                    <el-pagination v-if="identifierValuesData.length > 0" v-model:currentPage="valuesTablePage"
                        :page-size="valuesTablePageSize" :page-sizes="[50, 100, 200, 500]"
                        :total="identifierValuesData.length" layout="total, sizes, prev, pager, next" background
                        style="margin-top: 12px; justify-content: flex-end"
                        @size-change="(val) => { valuesTablePageSize = val; valuesTablePage = 1 }">
                    </el-pagination>
                </el-card>
            </el-tab-pane>
        </el-tabs>

        <!-- 云存储弹窗 -->
        <el-dialog v-model="cloudStorageDialog.visible"
            :title="'云存储信息 - ' + (cloudStorageDialog.deviceInfo.uuid || '设备')" width="85%">
            <div v-loading="cloudStorageDialog.loading">
                <el-empty v-if="!cloudStorageDialog.loading && cloudStorageDialog.data.length === 0"
                    description="暂无云存储数据" />
                <el-table v-else :data="cloudStorageDialog.data" stripe border size="small" max-height="500">
                    <el-table-column prop="order_id" label="订单ID" width="260" show-overflow-tooltip align="center" />
                    <el-table-column prop="uuid" label="设备UUID" width="260" show-overflow-tooltip align="center" />
                    <el-table-column prop="uid" label="用户UID" width="120" align="center" />
                    <el-table-column label="开始时间" width="150" align="center">
                        <template v-slot="{ row }">{{ formatTimestamp(row.start_time) }}</template>
                    </el-table-column>
                    <el-table-column label="过期时间" width="150" align="center">
                        <template v-slot="{ row }">{{ formatTimestamp(row.end_time) }}</template>
                    </el-table-column>
                    <el-table-column prop="file_time" label="存储时长(天)" width="110" align="center" />
                    <el-table-column label="订阅状态" width="90" align="center">
                        <template v-slot="{ row }">
                            <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
                                {{ row.status === 0 ? '未订阅' : row.status === 1 ? '已订阅' : '未知' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="云类型" width="80" align="center">
                        <template v-slot="{ row }">
                            <el-tag :type="row.is_event === 1 ? 'success' : 'info'" size="small">
                                {{ row.is_event === 0 ? '全时云' : row.is_event === 1 ? '事件云' : '未知' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="终端" width="80" align="center">
                        <template v-slot="{ row }">{{ appName[row.schema] || row.schema }}</template>
                    </el-table-column>
                    <el-table-column label="删除状态" align="center">
                        <template v-slot="{ row }">
                            <el-tag :type="row.is_delete === 0 ? 'success' : 'danger'" size="small">{{ row.is_delete ===
                                0 ? '未删除' : '已删除' }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="过期状态" align="center">
                        <template v-slot="{ row }">
                            <el-tag :type="!row.is_expired ? 'success' : 'warning'" size="small">{{ row.is_expired ?
                                '已过期' : '未过期' }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="套餐等级" align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small">{{ getLevelTextDynamic(row.level) }}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <template #footer><el-button size="small"
                    @click="cloudStorageDialog.visible = false">关闭</el-button></template>
        </el-dialog>

        <!-- 设备影子弹窗 -->
        <DeviceShadowDialog v-model="deviceShadowVisible" :shadow-data="deviceShadowDialog.data"
            :loading="deviceShadowDialog.loading" :device-info="deviceShadowDialog.deviceInfo"
            @close="closeDeviceShadowDialog" destroy-on-close />
    </div>
</template>

<script>
import { ref, reactive, computed, watch, nextTick, onMounted, onActivated, onBeforeUnmount, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import * as echarts from 'echarts'
import queryApi from '../../../axios/queryApi'
import DeviceShadowDialog from '../../../components/device/DeviceShadowDialog.vue'

dayjs.extend(utc)

const messageTypeMap = [
    { value: '移动侦测', key: 8 },
    { value: '声音侦测', key: 9 },
    { value: '内存侦测', key: 10 },
    { value: 'PIR侦测', key: 11 },
    { value: '门铃事件', key: 12 },
    { value: '低温侦测', key: 14 },
    { value: '高温侦测', key: 15 }
]

const openStatusMap = { 0: '休眠', 1: '开启' }
const onlineTypeMap = { 0: 'P2P', 1: 'MQTT' }
const mqOnlineMap = { 0: '不在线', 1: '在线' }
const p2pOnlineMap = { 0: '不在线', 1: '在线' }

function formatTimestamp(timestamp) {
    if (!timestamp || timestamp === 0) return '无'
    return dayjs.unix(timestamp).utc().format('YYYY-MM-DD HH:mm:ss')
}

function formatMillisTimestamp(timestamp) {
    if (!timestamp || timestamp === 0) return '无'
    return dayjs(timestamp).utc().format('YYYY-MM-DD HH:mm:ss')
}

// 将 Date 对象或字符串统一转为 YYYY-MM-DD HH:mm:ss 格式，空值返回空字符串
function toDateTimeStr(val) {
    if (!val) return ''
    if (typeof val === 'string') return val
    return dayjs(val).format('YYYY-MM-DD HH:mm:ss')
}

function formatIpAddress(ipInt) {
    if (!ipInt || ipInt === 0) return '无'
    const a = (ipInt >>> 24) & 0xff
    const b = (ipInt >>> 16) & 0xff
    const c = (ipInt >>> 8) & 0xff
    const d = ipInt & 0xff
    return a + '.' + b + '.' + c + '.' + d
}

function isValidJSON(str) {
    if (!str || str.trim() === '' || str === '0') return false
    try { JSON.parse(str); return true } catch { return false }
}

function formatJSON(str) {
    try { return JSON.stringify(JSON.parse(str), null, 2) } catch { return str }
}

function getMessageTypeName(key) {
    const type = messageTypeMap.find(item => item.key === key)
    return type ? type.value : ('类型' + key)
}

function getBatteryOnlineText(online_type, status) {
    const statusMap = online_type === 0
        ? { 1: '未充电', 2: '正在充电' }
        : { 0: '未充电', 1: '正在充电' }
    return statusMap[status] || '未知'
}

function getBatteryOnlineTagType(online_type, status) {
    return online_type === 0
        ? (status === 2 ? 'success' : 'danger')
        : (status === 1 ? 'success' : 'danger')
}

// 目前约定：型号以 WT10_ 开头的设备为猎机（打猎相机）
function isHuntingDevice(target) {
    if (!target) return false
    const model = typeof target === 'object' ? (target.model_code || target.model) : target
    if (typeof model !== 'string') return false
    return model.toUpperCase().startsWith('WT10_')
}

export default {
    name: 'QueryDeviceDetail',
    components: { DeviceShadowDialog },
    setup() {
        const { proxy } = getCurrentInstance()
        const route = useRoute()
        const router = useRouter()

        const activeTab = ref('deviceInfo')
        const searchForm = reactive({ uuid: '', region: 'us' })
        const deviceDetail = ref(null)
        const deviceUsers = ref([])
        const appName = reactive({})

        const loading = reactive({
            deviceDetail: false,
            deviceLogs: false,
            deviceMessage: false,
            deviceMessageChart: false,
            cloudVideo: false,
            identifierValues: false
        })

        // 设备日志
        const deviceLogsForm = reactive({ identifier: '', uid: '', start_time: '', end_time: '' })
        const deviceLogsList = ref([])
        const deviceLogsTypes = ref([])
        const deviceLogsPagination = reactive({ total: 0, pageSize: 15, currentPage: 1 })

        // 设备消息
        const deviceMessageForm = reactive({ type: null, start_time: '', end_time: '' })
        const deviceMessageList = ref([])
        const deviceMessagePagination = reactive({
            pageSize: 15, hasNextPage: false, hasPrevPage: false,
            currentFirstId: null, currentLastId: null, pageIndex: 1
        })
        // 设备消息 - 云视频存在性检查
        const messageCloudVideoStatus = reactive({}) // { messageId: true/false/'loading' }

        // 云视频
        const cloudVideoForm = reactive({ uid: '', file_date: '' })
        const cloudVideoList = ref([])
        const cloudVideoData = ref(null)
        const cloudVideoPagination = reactive({ total: 0, pageSize: 12, currentPage: 1 })

        // 属性值统计
        const identifierValuesForm = reactive({ identifier: '', uid: '', start_time: '', end_time: '' })
        const identifierValuesData = ref([])
        const identifierValuesChartReady = ref(false)
        const identifierValuesSearched = ref(false)
        const identifierValueTypes = ref([])
        const valuesTablePage = ref(1)
        const valuesTablePageSize = ref(100)

        const today = dayjs()
        const identifierValuesTimeRange = ref([
            today.subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            today.add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        ])

        var timeRangeShortcuts = computed(function () {
            var now = new Date()
            return [
                { text: '最近1小时', value: [new Date(now.getTime() - 3600000), now] },
                { text: '最近6小时', value: [new Date(now.getTime() - 21600000), now] },
                { text: '最近12小时', value: [new Date(now.getTime() - 43200000), now] },
                { text: '最近1天', value: [new Date(now.getTime() - 86400000), now] },
                { text: '最近3天', value: [new Date(now.getTime() - 259200000), now] },
                { text: '最近7天', value: [new Date(now.getTime() - 604800000), now] },
                { text: '最近30天', value: [new Date(now.getTime() - 2592000000), now] }
            ]
        })

        // 弹窗
        const cloudStorageDialog = reactive({ visible: false, loading: false, data: [], deviceInfo: {} })
        const deviceShadowDialog = reactive({ loading: false, data: null, deviceInfo: {} })
        const deviceShadowVisible = ref(false)
        const tslAttribute = reactive({})
        const levelMap = reactive({})

        // 4G设备网络情况
        const netInfo = reactive({
            trans_id: '', precord_id: '', pitem_id: '', sync_time: '',
            prev_plmn: '', curr_plmn: '', signal: '', card_imsi: '',
            card_vendor: '', cfg_oplmn: '', cfg_vendor: '', vendor_list: []
        })
        const netInfoImei = ref('')
        const netInfoLoading = ref(false)

        // 云视频分页 computed
        const pagedCloudVideoList = computed(function () {
            var start = (cloudVideoPagination.currentPage - 1) * cloudVideoPagination.pageSize
            var end = cloudVideoPagination.currentPage * cloudVideoPagination.pageSize
            return cloudVideoList.value.slice(start, end)
        })

        // echarts
        var valuesChart = null
        var deviceMessageChart = null
        const deviceMessageDailyRows = ref([])
        const deviceMessageChartHidden = ref(false)

        const deviceMessageDailyHitsText = computed(function () {
            var sum = deviceMessageDailyRows.value.reduce(function (s, r) {
                return s + (Number(r.msg_count) || 0)
            }, 0)
            return sum.toLocaleString('zh-CN') + ' 条消息'
        })

        const deviceMessageDailyRangeText = computed(function () {
            var rows = deviceMessageDailyRows.value
            if (!rows.length) return ''
            var sorted = rows.slice().sort(function (a, b) {
                return String(a.device_date).localeCompare(String(b.device_date))
            })
            var start = sorted[0].device_date
            var end = sorted[sorted.length - 1].device_date
            return start + ' 00:00:00 — ' + end + ' 23:59:59'
        })

        function disposeValuesChart() {
            if (valuesChart) { valuesChart.dispose(); valuesChart = null }
        }

        function disposeDeviceMessageChart() {
            if (deviceMessageChart) {
                deviceMessageChart.dispose()
                deviceMessageChart = null
            }
        }

        function renderDeviceMessageChart(rows) {
            var chartDom = document.getElementById('deviceMessageDailyChart')
            if (!chartDom) return
            var sorted = rows.slice().sort(function (a, b) {
                return String(a.device_date).localeCompare(String(b.device_date))
            })
            var dates = sorted.map(function (r) { return r.device_date })
            var counts = sorted.map(function (r) { return Number(r.msg_count) || 0 })

            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    formatter: function (params) {
                        var p = params[0]
                        return p.name + '<br/>消息数: ' + (p.value != null ? Number(p.value).toLocaleString('zh-CN') : '0')
                    }
                },
                grid: { left: 52, right: 14, top: 32, bottom: 32 },
                xAxis: {
                    type: 'category',
                    data: dates,
                    axisLabel: { fontSize: 11, color: '#606266' },
                    axisTick: { alignWithLabel: true }
                },
                yAxis: {
                    type: 'value',
                    name: 'Count',
                    nameTextStyle: { fontSize: 11, color: '#909399' },
                    min: 0,
                    splitLine: { lineStyle: { color: '#ebeef5' } },
                    axisLabel: {
                        fontSize: 11,
                        color: '#909399',
                        formatter: function (v) {
                            if (v >= 1000000) return (v / 1000000).toFixed(1) + 'M'
                            if (v >= 1000) return (v / 1000).toFixed(0) + 'k'
                            return v
                        }
                    }
                },
                series: [{
                    name: '消息数',
                    type: 'bar',
                    data: counts,
                    barCategoryGap: '3%',
                    itemStyle: {
                        color: '#00a398',
                        borderRadius: [2, 2, 0, 0]
                    }
                }]
            }

            if (!dates.length) {
                option.graphic = [{
                    type: 'text',
                    left: 'center',
                    top: 'middle',
                    style: { text: '暂无汇总数据', fill: '#909399', fontSize: 13 }
                }]
            }

            if (!deviceMessageChart || deviceMessageChart.isDisposed()) {
                deviceMessageChart = echarts.init(chartDom)
            }
            deviceMessageChart.clear()
            deviceMessageChart.setOption(option)
        }

        function loadDeviceMessageDailySummary() {
            if (!searchForm.uuid.trim()) {
                deviceMessageDailyRows.value = []
                disposeDeviceMessageChart()
                return
            }
            loading.deviceMessageChart = true
            queryApi.QueryDeviceMessageDailySummary({
                uuid: searchForm.uuid.trim(),
                region: searchForm.region
            }).then(function (res) {
                if (res.data.code === 200 && res.data.data) {
                    var inner = res.data.data.data
                    var rows = Array.isArray(inner) ? inner : []
                    deviceMessageDailyRows.value = rows
                    nextTick(function () {
                        if (!deviceMessageChartHidden.value) {
                            renderDeviceMessageChart(rows)
                        }
                    })
                } else {
                    deviceMessageDailyRows.value = []
                    disposeDeviceMessageChart()
                    proxy.$message.error(res.data.msg || '获取消息汇总失败')
                }
            }).catch(function () {
                deviceMessageDailyRows.value = []
                disposeDeviceMessageChart()
                proxy.$message.error('获取消息汇总失败')
            }).finally(function () {
                loading.deviceMessageChart = false
                nextTick(function () {
                    if (deviceMessageChart) deviceMessageChart.resize()
                })
            })
        }

        function getIdentifierLabel(key) {
            var item = identifierValueTypes.value.find(function (t) { return t.key === key })
            return item ? (item.name || item.value) : key
        }

        function formatCloudVideoTime(filedate, seconds) {
            if (!filedate || seconds === undefined) return '无'
            var year = filedate.substring(0, 4)
            var month = filedate.substring(4, 6)
            var day = filedate.substring(6, 8)
            var date = dayjs.utc(year + '-' + month + '-' + day).add(seconds, 'second')
            return date.format('YYYY-MM-DD HH:mm:ss')
        }

        // ===== API 调用函数 =====
        function searchDeviceDetail() {
            if (!searchForm.uuid.trim()) { proxy.$message.warning('请输入设备UUID'); return }
            loading.deviceDetail = true
            queryApi.QueryDeviceDetail({ code: searchForm.uuid, region: searchForm.region }).then(function (res) {
                if (res.data.code == 200 && res.data.data) {
                    deviceDetail.value = res.data.data
                    deviceUsers.value = res.data.data.device_users || []
                    // 4G设备加载网络情况
                    if (isSimdataModel(res.data.data.device)) {
                        getNetInfo()
                    }
                } else {
                    proxy.$message.error(res.data.msg || '获取设备详情失败')
                    deviceDetail.value = null
                    deviceUsers.value = []
                }
            }).catch(function () {
                proxy.$message.error('获取设备详情失败')
                deviceDetail.value = null
                deviceUsers.value = []
            }).finally(function () { loading.deviceDetail = false })
        }

        function fetchDeviceLogsTypes() {
            queryApi.QueryDeviceLogsType({ region: searchForm.region }).then(function (res) {
                if (res.data.code == 200 && res.data.data) {
                    deviceLogsTypes.value = res.data.data.list || []
                }
            }).catch(function (err) { console.error('获取设备日志类型失败:', err) })
        }

        function fetchIdentifierValueTypes() {
            queryApi.QueryDeviceLogsValueType({ region: searchForm.region }).then(function (res) {
                if (res.data.code == 200 && res.data.data) {
                    var list = res.data.data.list || []
                    identifierValueTypes.value = list
                }
            }).catch(function (err) { console.error('获取属性值类型列表失败:', err) })
        }

        function searchDeviceLogs() {
            if (!searchForm.uuid.trim()) { proxy.$message.warning('请先输入设备UUID'); return }
            loading.deviceLogs = true
            var params = {
                device_id: searchForm.uuid,
                region: searchForm.region,
                page: deviceLogsPagination.currentPage,
                limit: deviceLogsPagination.pageSize,
                identifier: deviceLogsForm.identifier,
                uid: deviceLogsForm.uid,
                start_time: toDateTimeStr(deviceLogsForm.start_time),
                end_time: toDateTimeStr(deviceLogsForm.end_time)
            }
            queryApi.QueryDeviceLogs(params).then(function (res) {
                if (res.data.code == 200 && res.data.data) {
                    deviceLogsList.value = res.data.data.list || []
                    deviceLogsPagination.total = (res.data.data.page_info && res.data.data.page_info.total) || 0
                    deviceLogsPagination.currentPage = (res.data.data.page_info && res.data.data.page_info.current_page) || 1
                } else {
                    proxy.$message.error(res.data.msg || '获取设备日志失败')
                    deviceLogsList.value = []
                    deviceLogsPagination.total = 0
                }
            }).catch(function () {
                proxy.$message.error('获取设备日志失败')
                deviceLogsList.value = []
                deviceLogsPagination.total = 0
            }).finally(function () { loading.deviceLogs = false })
        }

        function resetDeviceMessagePagination() {
            deviceMessagePagination.hasNextPage = false
            deviceMessagePagination.hasPrevPage = false
            deviceMessagePagination.currentFirstId = null
            deviceMessagePagination.currentLastId = null
            deviceMessagePagination.pageIndex = 1
        }

        function searchDeviceMessage(action) {
            if (!searchForm.uuid.trim()) { proxy.$message.warning('请先输入设备UUID'); return }
            loading.deviceMessage = true
            var params = {
                uuid: searchForm.uuid,
                rows: deviceMessagePagination.pageSize,
                region: searchForm.region,
                type: deviceMessageForm.type,
                start_time: deviceMessageForm.start_time ? (typeof deviceMessageForm.start_time === 'object' ? Math.floor(deviceMessageForm.start_time.getTime() / 1000) : deviceMessageForm.start_time) : '',
                end_time: deviceMessageForm.end_time ? (typeof deviceMessageForm.end_time === 'object' ? Math.floor(deviceMessageForm.end_time.getTime() / 1000) : deviceMessageForm.end_time) : ''
            }
            if (action) {
                params.action = action
                if (action === 1 && deviceMessagePagination.currentFirstId) {
                    params.last_id = deviceMessagePagination.currentFirstId
                } else if (action === 2 && deviceMessagePagination.currentLastId) {
                    params.last_id = deviceMessagePagination.currentLastId
                }
            }
            queryApi.QueryDeviceMessageList(params).then(function (res) {
                if (res.data.code == 200 && res.data.data) {
                    var data = Array.isArray(res.data.data) ? res.data.data : (res.data.data.data || [])
                    deviceMessageList.value = data
                    if (data.length > 0) {
                        deviceMessagePagination.currentFirstId = data[0].id
                        deviceMessagePagination.currentLastId = data[data.length - 1].id
                        if (!action) {
                            deviceMessagePagination.pageIndex = 1
                        } else if (action === 2) {
                            deviceMessagePagination.pageIndex++
                        } else if (action === 1) {
                            deviceMessagePagination.pageIndex--
                        }
                    }
                    deviceMessagePagination.hasNextPage = data.length === deviceMessagePagination.pageSize
                    deviceMessagePagination.hasPrevPage = deviceMessagePagination.pageIndex > 1
                    // 检查云视频存在性
                    checkMessageCloudVideoStatus(data)
                } else {
                    proxy.$message.error(res.data.msg || '获取设备消息失败')
                    deviceMessageList.value = []
                    resetDeviceMessagePagination()
                }
            }).catch(function () {
                proxy.$message.error('获取设备消息失败')
                deviceMessageList.value = []
                resetDeviceMessagePagination()
            }).finally(function () { loading.deviceMessage = false })
        }

        // ===== 云视频缓存 & 消息云视频存在性检查 =====
        // 使用 localStorage 缓存，仅在登录失效/注销时（localStorage.clear()）才清除
        var CV_CACHE_PREFIX = 'cv_cache_'

        function getCloudVideoCacheKey(uuid, dateStr) {
            return CV_CACHE_PREFIX + uuid + '_' + dateStr
        }

        function getCloudVideoFromCache(uuid, dateStr) {
            try {
                var raw = localStorage.getItem(getCloudVideoCacheKey(uuid, dateStr))
                return raw ? JSON.parse(raw) : null
            } catch (e) { return null }
        }

        function setCloudVideoToCache(uuid, dateStr, data) {
            try {
                localStorage.setItem(getCloudVideoCacheKey(uuid, dateStr), JSON.stringify(data))
            } catch (e) { /* ignore */ }
        }

        // YYYYMMDD -> 该日 UTC 0 点秒级时间戳（与 isTimeInCloudVideo 一致）
        function getUtcDayStartFromYyyymmdd(dateStr) {
            if (!dateStr || dateStr.length < 8) return 0
            var year = parseInt(dateStr.substring(0, 4), 10)
            var month = parseInt(dateStr.substring(4, 6), 10)
            var day = parseInt(dateStr.substring(6, 8), 10)
            return Date.UTC(year, month - 1, day) / 1000
        }

        // 设备上报时间相对当天 UTC 0 点已过去的秒数
        function getDeviceSecondsSinceUtcDayStart(deviceTimestamp) {
            if (deviceTimestamp === undefined || deviceTimestamp === null) return 0
            var d = dayjs.unix(deviceTimestamp).utc()
            var dateStr = d.format('YYYYMMDD')
            var dayStart = getUtcDayStartFromYyyymmdd(dateStr)
            return deviceTimestamp - dayStart
        }

        // 缓存的云视频片段中，相对当天 0 点覆盖到的最大结束秒数 max(s + l)
        function getCloudVideoCachedMaxEndSeconds(fileinfo) {
            if (!fileinfo || fileinfo.length === 0) return 0
            var maxEnd = 0
            for (var i = 0; i < fileinfo.length; i++) {
                var s = Number(fileinfo[i].s) || 0
                var l = Number(fileinfo[i].l) || 0
                var end = s + l
                if (end > maxEnd) maxEnd = end
            }
            return maxEnd
        }

        // 检查某个秒级时间戳是否落在云视频时间段内（前后各 3 秒容差，片段范围钳制在当天 0~86400 秒内）
        const CLOUD_VIDEO_TIME_TOLERANCE = 3
        const SECONDS_PER_DAY = 86400
        function isTimeInCloudVideo(deviceTimestamp, filedate, fileinfo) {
            if (!filedate || !fileinfo || fileinfo.length === 0) return false
            const year = filedate.substring(0, 4)
            const month = filedate.substring(4, 6)
            const day = filedate.substring(6, 8)
            // 当天 0 点的 UTC 秒级时间戳
            const dayStartUtc = Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)) / 1000
            for (let i = 0; i < fileinfo.length; i++) {
                const s = Number(fileinfo[i].s) || 0
                const l = Number(fileinfo[i].l) || 0
                const segStart = dayStartUtc + Math.max(s - CLOUD_VIDEO_TIME_TOLERANCE, 0)
                const segEnd = dayStartUtc + Math.min(s + l + CLOUD_VIDEO_TIME_TOLERANCE, SECONDS_PER_DAY)
                if (deviceTimestamp >= segStart && deviceTimestamp <= segEnd) return true
            }
            return false
        }

        // 获取主人用户的 uid 和 bind_type
        function getOwnerInfo() {
            var ownerUser = deviceUsers.value.find(function (u) { return u.bind_type === 1 })
            return ownerUser ? { uid: ownerUser.uid, bind_type: 1 } : null
        }

        // 消息列表加载后，检查云视频存在性
        function checkMessageCloudVideoStatus(messages) {
            if (!messages || messages.length === 0) return
            var owner = getOwnerInfo()
            if (!owner) return

            // 提取所有消息涉及的日期（YYYYMMDD 格式）
            var dateSet = {}
            messages.forEach(function (msg) {
                if (msg.device_time) {
                    var d = dayjs.unix(msg.device_time).utc()
                    var dateStr = d.format('YYYYMMDD')
                    dateSet[dateStr] = true
                }
            })

            var dates = Object.keys(dateSet)
            var pendingDates = []
            var pendingSet = {}

            function addPendingDate(dateStr) {
                if (!pendingSet[dateStr]) {
                    pendingSet[dateStr] = true
                    pendingDates.push(dateStr)
                }
            }

            // 先检查缓存：无缓存要拉取；有缓存若某条消息「当天内秒数」大于缓存片段最大结束秒数，说明可能后来新增了更晚的云视频，需刷新当天
            dates.forEach(function (dateStr) {
                var cached = getCloudVideoFromCache(searchForm.uuid, dateStr)
                if (cached === null) {
                    addPendingDate(dateStr)
                    return
                }
                var maxMsgSec = 0
                messages.forEach(function (msg) {
                    if (!msg.device_time) return
                    var d = dayjs.unix(msg.device_time).utc()
                    if (d.format('YYYYMMDD') !== dateStr) return
                    var sec = getDeviceSecondsSinceUtcDayStart(msg.device_time)
                    if (sec > maxMsgSec) maxMsgSec = sec
                })
                var cachedMaxEnd = getCloudVideoCachedMaxEndSeconds(cached.fileinfo)
                if (cached.fileinfo && cached.fileinfo.length > 0 && maxMsgSec > cachedMaxEnd) {
                    addPendingDate(dateStr)
                }
            })

            // 标记所有消息为 loading
            messages.forEach(function (msg) {
                if (msg.id) messageCloudVideoStatus[msg.id] = 'loading'
            })

            // 如果有未缓存的日期，请求接口
            var fetchPromises = pendingDates.map(function (dateStr) {
                return queryApi.QueryCloudFileList({
                    uuid: searchForm.uuid,
                    uid: owner.uid,
                    region: searchForm.region,
                    file_date: dateStr,
                    bind_type: owner.bind_type
                }).then(function (res) {
                    if (res.data.code == 200 && res.data.data) {
                        setCloudVideoToCache(searchForm.uuid, dateStr, {
                            filedate: res.data.data.filedate || dateStr,
                            fileinfo: res.data.data.fileinfo || []
                        })
                    } else {
                        // 缓存空结果，避免重复请求
                        setCloudVideoToCache(searchForm.uuid, dateStr, { filedate: dateStr, fileinfo: [] })
                    }
                }).catch(function () {
                    setCloudVideoToCache(searchForm.uuid, dateStr, { filedate: dateStr, fileinfo: [] })
                })
            })

            Promise.all(fetchPromises).then(function () {
                // 所有日期数据就绪，逐条判断
                messages.forEach(function (msg) {
                    if (!msg.device_time || !msg.id) {
                        messageCloudVideoStatus[msg.id] = false
                        return
                    }
                    var d = dayjs.unix(msg.device_time).utc()
                    var dateStr = d.format('YYYYMMDD')
                    var cached = getCloudVideoFromCache(searchForm.uuid, dateStr)
                    if (cached && cached.fileinfo && cached.fileinfo.length > 0) {
                        messageCloudVideoStatus[msg.id] = isTimeInCloudVideo(msg.device_time, cached.filedate, cached.fileinfo)
                    } else {
                        messageCloudVideoStatus[msg.id] = false
                    }
                })
            })
        }

        function searchCloudVideoList() {
            if (!searchForm.uuid.trim()) { proxy.$message.warning('请先输入设备UUID'); return }
            if (!cloudVideoForm.file_date) { proxy.$message.warning('请选择日期'); return }
            var bind_type = 1
            if (cloudVideoForm.uid) {
                var user = deviceUsers.value.find(function (u) { return u.uid === cloudVideoForm.uid })
                if (user) bind_type = user.bind_type
            } else {
                var ownerUser = deviceUsers.value.find(function (u) { return u.bind_type === 1 })
                if (ownerUser) { cloudVideoForm.uid = ownerUser.uid }
                else { proxy.$message.warning('未找到主人绑定的用户'); return }
            }
            loading.cloudVideo = true
            // file_date 可能是 Date 对象或字符串，统一转为 YYYYMMDD 格式
            var dateVal = cloudVideoForm.file_date
            var formattedDate = ''
            if (typeof dateVal === 'string') {
                formattedDate = dateVal.replace(/-/g, '')
            } else if (dateVal instanceof Date) {
                formattedDate = dayjs(dateVal).format('YYYYMMDD')
            } else {
                formattedDate = dayjs(dateVal).format('YYYYMMDD')
            }
            queryApi.QueryCloudFileList({
                uuid: searchForm.uuid, uid: cloudVideoForm.uid, region: searchForm.region,
                file_date: formattedDate, bind_type: bind_type
            }).then(function (res) {
                if (res.data.code == 200 && res.data.data) {
                    cloudVideoData.value = res.data.data
                    cloudVideoList.value = res.data.data.fileinfo || []
                    cloudVideoPagination.total = cloudVideoList.value.length
                    cloudVideoPagination.currentPage = 1
                } else {
                    proxy.$message.error(res.data.msg || '获取云视频列表失败')
                    cloudVideoData.value = null
                    cloudVideoList.value = []
                    cloudVideoPagination.total = 0
                }
            }).catch(function () {
                proxy.$message.error('获取云视频列表失败')
                cloudVideoData.value = null
                cloudVideoList.value = []
                cloudVideoPagination.total = 0
            }).finally(function () { loading.cloudVideo = false })
        }

        function searchIdentifierValues() {
            if (!searchForm.uuid.trim()) { proxy.$message.warning('请先输入设备UUID'); return }
            if (!identifierValuesForm.identifier) { proxy.$message.warning('请选择属性/事件'); return }
            if (!identifierValuesForm.start_time || !identifierValuesForm.end_time) { proxy.$message.warning('请选择时间范围'); return }
            loading.identifierValues = true
            var params = {
                device_id: searchForm.uuid, region: searchForm.region,
                identifier: identifierValuesForm.identifier,
                start_time: identifierValuesForm.start_time,
                end_time: identifierValuesForm.end_time
            }
            if (identifierValuesForm.uid) params.uid = identifierValuesForm.uid
            queryApi.QueryIdentifierValues(params).then(function (res) {
                identifierValuesSearched.value = true
                if (res.data.code == 200) {
                    var list = (res.data.data && res.data.data.list) || res.data.data || []
                    if (Array.isArray(list) && list.length > 0) {
                        list.forEach(function (item) {
                            if (item.created_at) item.created_at = dayjs(item.created_at).format('YYYY-MM-DD HH:mm:ss')
                        })
                        identifierValuesData.value = list
                        identifierValuesChartReady.value = true
                    } else {
                        identifierValuesData.value = []
                        identifierValuesChartReady.value = false
                    }
                } else {
                    proxy.$message.error(res.data.msg || '查询失败')
                    identifierValuesData.value = []
                    identifierValuesChartReady.value = false
                }
            }).catch(function () {
                proxy.$message.error('属性值查询失败')
                identifierValuesData.value = []
                identifierValuesChartReady.value = false
            }).finally(function () { loading.identifierValues = false })
        }

        // ===== 统一搜索 =====
        function searchAllTabs() {
            if (!searchForm.uuid.trim()) { proxy.$message.warning('请输入设备UUID'); return }
            searchDeviceDetail()
            searchDeviceLogs()
            searchDeviceMessage()
            loadDeviceMessageDailySummary()
        }

        function handleTopSearch() {
            if (!searchForm.uuid.trim()) { proxy.$message.warning('请输入设备UUID'); return }

            // 基础查询始终执行
            searchDeviceDetail()
            searchDeviceLogs()
            searchDeviceMessage()
            loadDeviceMessageDailySummary()

            // 根据当前 tab 自动触发对应查询（条件满足时）
            var tab = activeTab.value
            if (tab === 'identifierValues') {
                // 同步时间范围
                if (identifierValuesTimeRange.value) {
                    var startVal = identifierValuesTimeRange.value[0]
                    var endVal = identifierValuesTimeRange.value[1]
                    identifierValuesForm.start_time = typeof startVal === 'string' ? startVal : dayjs(startVal).format('YYYY-MM-DD HH:mm:ss')
                    identifierValuesForm.end_time = typeof endVal === 'string' ? endVal : dayjs(endVal).format('YYYY-MM-DD HH:mm:ss')
                }
                if (identifierValuesForm.identifier && identifierValuesForm.start_time && identifierValuesForm.end_time) {
                    searchIdentifierValues()
                }
            } else if (tab === 'cloudVideo') {
                if (cloudVideoForm.uid && cloudVideoForm.file_date) {
                    searchCloudVideoList()
                }
            }
        }

        // ===== 分页处理 =====
        function handleDeviceLogsPageChange(page) {
            deviceLogsPagination.currentPage = page
            searchDeviceLogs()
        }
        function handleDeviceLogsSizeChange(size) {
            deviceLogsPagination.pageSize = size
            deviceLogsPagination.currentPage = 1
            searchDeviceLogs()
        }
        function handleDeviceMessagePrevPage() {
            if (deviceMessagePagination.hasPrevPage) searchDeviceMessage(1)
        }
        function handleDeviceMessageNextPage() {
            if (deviceMessagePagination.hasNextPage) searchDeviceMessage(2)
        }
        function handleDeviceMessageSizeChange(size) {
            deviceMessagePagination.pageSize = size
            resetDeviceMessagePagination()
            searchDeviceMessage()
        }
        function handleCloudVideoPageChange(page) { cloudVideoPagination.currentPage = page }
        function handleCloudVideoSizeChange(size) {
            cloudVideoPagination.pageSize = size
            cloudVideoPagination.currentPage = 1
        }

        // ===== 重置表单 =====
        function resetDeviceLogsForm() {
            Object.assign(deviceLogsForm, { identifier: '', uid: '', start_time: '', end_time: '' })
            deviceLogsPagination.currentPage = 1
            searchDeviceLogs()
        }
        function resetDeviceMessageForm() {
            Object.assign(deviceMessageForm, { type: null, start_time: '', end_time: '' })
            resetDeviceMessagePagination()
            searchDeviceMessage()
        }
        function resetCloudVideoForm() {
            Object.assign(cloudVideoForm, { uid: '', file_date: '' })
            cloudVideoData.value = null
            cloudVideoList.value = []
            cloudVideoPagination.total = 0
            cloudVideoPagination.currentPage = 1
        }
        function resetIdentifierValuesForm() {
            Object.assign(identifierValuesForm, { identifier: '', uid: '', start_time: '', end_time: '' })
            identifierValuesData.value = []
            identifierValuesChartReady.value = false
            identifierValuesSearched.value = false
        }

        function handleIdentifierValuesSearch() {
            if (identifierValuesTimeRange.value) {
                var startVal = identifierValuesTimeRange.value[0]
                var endVal = identifierValuesTimeRange.value[1]
                // el-date-picker 可能返回 Date 对象或字符串，统一转为 YYYY-MM-DD HH:mm:ss
                identifierValuesForm.start_time = typeof startVal === 'string' ? startVal : dayjs(startVal).format('YYYY-MM-DD HH:mm:ss')
                identifierValuesForm.end_time = typeof endVal === 'string' ? endVal : dayjs(endVal).format('YYYY-MM-DD HH:mm:ss')
            } else {
                identifierValuesForm.start_time = ''
                identifierValuesForm.end_time = ''
            }
            searchIdentifierValues()
            valuesTablePage.value = 1
        }

        function handleIdentifierValuesReset() {
            var resetToday = dayjs()
            identifierValuesTimeRange.value = [
                resetToday.subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                resetToday.add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
            ]
            resetIdentifierValuesForm()
            disposeValuesChart()
        }

        // ===== 导航 =====
        function viewUserDetail(row) {
            if (!row.uid || !searchForm.region) { proxy.$message.error('缺少必要参数'); return }
            router.push({ path: '/iot/query/userdetail/' + row.uid + '&' + searchForm.region })
        }

        // ===== 弹窗操作 =====
        function viewCloudStorage(row) {
            if (!row.uid || !searchForm.uuid) { proxy.$message.error('缺少必要参数'); return }
            cloudStorageDialog.loading = true
            queryApi.QueryUserDeviceCloudInfo({ uid: row.uid, uuid: searchForm.uuid, region: searchForm.region }).then(function (res) {
                if (res.data.code == 200 && res.data.data) {
                    if (Array.isArray(res.data.data) && res.data.data.length === 0) {
                        proxy.$message.info('暂无云存储数据')
                        return
                    }
                    cloudStorageDialog.deviceInfo = { uuid: searchForm.uuid, name: (deviceDetail.value && deviceDetail.value.device && deviceDetail.value.device.name) || '未知设备' }
                    cloudStorageDialog.data = res.data.data
                    cloudStorageDialog.visible = true
                } else { proxy.$message.error(res.data.msg || '获取云存储信息失败') }
            }).catch(function () { proxy.$message.error('获取云存储信息失败') })
                .finally(function () { cloudStorageDialog.loading = false })
        }

        function viewDeviceShadow(row) {
            if (!row.uid || !searchForm.uuid) { proxy.$message.error('缺少必要参数'); return }
            deviceShadowDialog.loading = true
            deviceShadowVisible.value = true
            deviceShadowDialog.deviceInfo = { uuid: searchForm.uuid, name: (deviceDetail.value && deviceDetail.value.device && deviceDetail.value.device.name) || '未知设备' }
            deviceShadowDialog.data = null
            queryApi.QueryUserDeviceShadow({ uid: row.uid, uuid: searchForm.uuid, region: searchForm.region }).then(function (res) {
                if (res.data.code == 200 && res.data.data) {
                    deviceShadowDialog.data = {
                        shadow: res.data.data,
                        tsl_attribute: { ...tslAttribute }
                    }
                } else { proxy.$message.error(res.data.msg || '获取设备影子信息失败') }
            }).catch(function () { proxy.$message.error('获取设备影子信息失败') })
                .finally(function () { deviceShadowDialog.loading = false })
        }

        function closeDeviceShadowDialog() {
            deviceShadowVisible.value = false
            deviceShadowDialog.data = null
        }

        // ===== 4G设备网络情况 =====
        // 判断是否4G设备：优先用接口返回的 network_type（1-wifi 2-4g），
        // 接口未返回时回退到型号前缀判断
        function isSimdataModel(target) {
            if (!target) return false
            if (typeof target === 'object') {
                var networkType = target.network_type
                if (networkType !== null && networkType !== undefined && networkType !== '') {
                    return Number(networkType) === 2
                }
                return isSimdataModel(target.model_code || target.model)
            }
            if (typeof target !== 'string') return false
            return target.startsWith('GW41_') || target.startsWith('GW40_')
        }

        // 从已绑定用户的设备影子里取SIMData.IMEI
        function getImeiFromShadow() {
            var bindUser = deviceUsers.value.find(function (u) { return u.status == 1 }) || deviceUsers.value[0]
            if (!bindUser) return Promise.resolve('')
            return queryApi.QueryUserDeviceShadow({ uid: bindUser.uid, uuid: searchForm.uuid, region: searchForm.region })
                .then(function (res) {
                    if (res.data.code == 200) {
                        var reported = res.data.data && res.data.data.state && res.data.data.state.reported
                        var simData = reported && (reported.SIMData || reported.SimData)
                        return (simData && simData.IMEI) || ''
                    }
                    return ''
                }).catch(function () { return '' })
        }

        function getNetInfo() {
            // 先从device_info里拿imei，没有再从影子里拿SIMData.IMEI
            var infoImei = deviceDetail.value && deviceDetail.value.device_info && deviceDetail.value.device_info.imei
            var imeiPromise = infoImei ? Promise.resolve(infoImei) : getImeiFromShadow()

            netInfoLoading.value = true
            imeiPromise.then(function (imei) {
                if (!imei) {
                    netInfoLoading.value = false
                    proxy.$message.error('未获取到设备IMEI')
                    return
                }
                netInfoImei.value = imei
                queryApi.QueryDeviceNetInfo({ imei: imei, region: searchForm.region }).then(function (res) {
                    netInfoLoading.value = false
                    if (res.data.code == 200) {
                        var data = res.data.data || {}
                        var vendorList = data.vendor_list || []
                        // 返回的cfg_vendor不准确，用card_vendor(名称)匹配vendor_list得到供应商ID
                        var matchedVendor = vendorList.find(function (item) { return item.name === data.card_vendor })
                        Object.assign(netInfo, data, {
                            vendor_list: vendorList,
                            cfg_vendor: matchedVendor ? matchedVendor.id : ''
                        })
                        return
                    }
                    proxy.$message.error('获取失败' + res.data.msg)
                }).catch(function () { netInfoLoading.value = false })
            })
        }

        function updateNetInfo() {
            if (!netInfoImei.value) {
                proxy.$message.error('未获取到设备IMEI')
                return
            }
            proxy.$confirm('确定更新当前设备的4G网络配置？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                netInfoLoading.value = true
                queryApi.QueryDeviceNetUpdate({
                    imei: netInfoImei.value,
                    cfg_vendor: Number(netInfo.cfg_vendor) || 0,
                    cfg_oplmn: netInfo.cfg_oplmn || '',
                    region: searchForm.region
                }).then(function (res) {
                    netInfoLoading.value = false
                    if (res.data.code == 200) {
                        proxy.$message.success('更新成功')
                        getNetInfo()
                        return
                    }
                    proxy.$message.error('更新失败' + res.data.msg)
                }).catch(function () { netInfoLoading.value = false })
            }).catch(function () { })
        }

        function getAppList() {
            queryApi.QueryAppList({ page: 1, limit: 100 }).then(function (res) {
                if (res.data.code == 200) {
                    res.data.data.data.forEach(function (item) { appName[item.code] = item.name })
                }
            })
        }

        function getTslAttributeList() {
            queryApi.QueryTslAttributeList({ page: 1, rows: 500 }).then(function (res) {
                if (res.data.code == 200) {
                    res.data.data.data.forEach(function (item) {
                        tslAttribute[item.identifier] = item
                    })
                }
            })
        }

        function fetchPackageLevelList() {
            queryApi.QueryPackageLevelList({}).then(function (res) {
                if (res.data.code == 200) {
                    res.data.data.data.forEach(function (item) {
                        levelMap[item.set_meal_level] = item.level_name
                    })
                }
            })
        }

        function getLevelTextDynamic(level) {
            return levelMap[level] || ('等级' + level)
        }

        // ===== ECharts 渲染 =====
        function renderValuesChart(list) {
            var chartDom = document.getElementById('identifierValuesChart')
            if (!chartDom) return
            var label = getIdentifierLabel(identifierValuesForm.identifier)
            var startTime = identifierValuesForm.start_time
            var endTime = identifierValuesForm.end_time
            if (!startTime || !endTime) return

            var rawData = list.map(function (item) {
                var t = dayjs(item.created_at)
                if (!t.isValid()) return null
                var val = Number(item.value)
                if (isNaN(val)) return null
                return [t.valueOf(), val]
            }).filter(Boolean)

            rawData.sort(function (a, b) { return a[0] - b[0] })

            var noDataAreas = []
            if (rawData.length > 1) {
                var gapThreshold = 86400000
                for (var i = 1; i < rawData.length; i++) {
                    var gap = rawData[i][0] - rawData[i - 1][0]
                    if (gap > gapThreshold) {
                        noDataAreas.push({ start: rawData[i - 1][0], end: rawData[i][0] })
                    }
                }
            }

            var markAreaData = noDataAreas.map(function (area) {
                return [
                    { xAxis: area.start, itemStyle: { color: 'rgba(200, 200, 200, 0.3)' }, name: '无数据' },
                    { xAxis: area.end }
                ]
            })

            var largeMode = rawData.length > 500
            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'cross', label: { backgroundColor: '#6a7985' } },
                    formatter: function (params) {
                        if (!Array.isArray(params) || params.length === 0) return ''
                        var p = params[0]
                        var time = dayjs(p.value[0]).format('YYYY-MM-DD HH:mm:ss')
                        return time + '<br/>' + p.marker + ' ' + p.seriesName + ': ' + p.value[1]
                    }
                },
                legend: { data: [label], top: 0 },
                grid: { left: '3%', right: '4%', bottom: '15%', top: 40, containLabel: true },
                toolbox: { feature: { saveAsImage: {} } },
                dataZoom: [
                    { type: 'inside', start: 0, end: 100 },
                    { type: 'slider', start: 0, end: 100, bottom: 10 }
                ],
                xAxis: {
                    type: 'time',
                    min: dayjs(startTime).valueOf(),
                    max: dayjs(endTime).valueOf(),
                    axisLabel: {
                        hideOverlap: true,
                        formatter: function (val) {
                            var d = dayjs(val)
                            if (d.hour() === 0 && d.minute() === 0 && d.second() === 0) return d.format('MM-DD')
                            return d.format('MM-DD\nHH:mm')
                        }
                    }
                },
                yAxis: { type: 'value' },
                series: [{
                    name: label, type: 'line', smooth: !largeMode, showSymbol: true,
                    symbolSize: largeMode ? 4 : 6,
                    sampling: largeMode ? 'lttb' : undefined,
                    large: largeMode, largeThreshold: 500,
                    areaStyle: { opacity: 0.15 },
                    itemStyle: { color: '#5470c6' },
                    data: rawData,
                    markArea: { silent: true, label: { show: true, position: 'inside', color: '#999', fontSize: 12 }, data: markAreaData }
                }]
            }

            if (!valuesChart || valuesChart.isDisposed()) {
                valuesChart = echarts.init(chartDom)
            }
            valuesChart.clear()
            valuesChart.setOption(option)
        }

        function handleValuesResize() {
            if (valuesChart) valuesChart.resize()
            if (deviceMessageChart) deviceMessageChart.resize()
        }

        // ===== Watch =====
        watch(function () { return identifierValuesData.value }, function (newData) {
            if (identifierValuesChartReady.value && newData.length > 0) {
                nextTick(function () { renderValuesChart(newData) })
            }
        })

        watch(function () { return deviceUsers.value }, function (newUsers) {
            if (newUsers.length > 0) {
                var ownerUser = newUsers.find(function (u) { return u.bind_type === 1 })
                if (ownerUser) cloudVideoForm.uid = ownerUser.uid
                else cloudVideoForm.uid = ''
            }
        }, { deep: true })

        watch(deviceMessageChartHidden, function (hidden) {
            if (hidden) {
                disposeDeviceMessageChart()
            } else {
                nextTick(function () {
                    renderDeviceMessageChart(deviceMessageDailyRows.value)
                    if (deviceMessageChart) deviceMessageChart.resize()
                })
            }
        })

        watch(activeTab, function (tab) {
            if (tab === 'deviceMessage') {
                nextTick(function () {
                    if (deviceMessageChart) deviceMessageChart.resize()
                })
            }
        })

        // ===== 生命周期 =====
        onMounted(function () {
            var queryUuid = route.query.uuid
            var queryRegion = route.query.region
            var queryUid = route.query.uid

            if (queryUuid) searchForm.uuid = queryUuid
            if (queryRegion) searchForm.region = queryRegion
            if (queryUid) cloudVideoForm.uid = queryUid

            fetchDeviceLogsTypes()
            fetchIdentifierValueTypes()
            getAppList()
            getTslAttributeList()
            fetchPackageLevelList()

            if (queryUuid) searchAllTabs()

            window.addEventListener('resize', handleValuesResize)
        })

        // keep-alive 缓存组件被重新激活时，同步路由参数并重新查询
        onActivated(function () {
            var queryUuid = route.query.uuid
            var queryRegion = route.query.region
            var queryUid = route.query.uid

            var needRefresh = false
            if (queryUuid && queryUuid !== searchForm.uuid) {
                searchForm.uuid = queryUuid
                needRefresh = true
            }
            if (queryRegion && queryRegion !== searchForm.region) {
                searchForm.region = queryRegion
                needRefresh = true
            }
            if (queryUid) cloudVideoForm.uid = queryUid

            if (needRefresh && searchForm.uuid) {
                searchAllTabs()
            }
        })

        onBeforeUnmount(function () {
            window.removeEventListener('resize', handleValuesResize)
            disposeValuesChart()
            disposeDeviceMessageChart()
        })

        return {
            activeTab, searchForm, deviceDetail, deviceUsers, appName, loading,
            deviceLogsForm, deviceLogsList, deviceLogsTypes, deviceLogsPagination,
            deviceMessageForm, deviceMessageList, deviceMessagePagination, messageTypeMap, messageCloudVideoStatus,
            deviceMessageDailyHitsText, deviceMessageDailyRangeText, deviceMessageChartHidden,
            cloudVideoForm, cloudVideoList, cloudVideoData, cloudVideoPagination, pagedCloudVideoList,
            identifierValuesForm, identifierValuesData, identifierValuesChartReady, identifierValuesSearched,
            identifierValueTypes, identifierValuesTimeRange, timeRangeShortcuts,
            valuesTablePage, valuesTablePageSize,
            cloudStorageDialog, deviceShadowDialog, deviceShadowVisible,
            netInfo, netInfoImei, netInfoLoading, isSimdataModel, isHuntingDevice, getNetInfo, updateNetInfo,
            openStatusMap, onlineTypeMap, mqOnlineMap, p2pOnlineMap,
            formatTimestamp, formatMillisTimestamp, formatIpAddress, isValidJSON, formatJSON,
            getMessageTypeName, getBatteryOnlineText, getBatteryOnlineTagType, getLevelTextDynamic,
            getIdentifierLabel, formatCloudVideoTime,
            handleTopSearch, searchDeviceLogs, searchDeviceMessage, searchCloudVideoList, searchIdentifierValues,
            handleDeviceLogsPageChange, handleDeviceLogsSizeChange,
            handleDeviceMessagePrevPage, handleDeviceMessageNextPage, handleDeviceMessageSizeChange,
            handleCloudVideoPageChange, handleCloudVideoSizeChange,
            handleIdentifierValuesSearch, handleIdentifierValuesReset,
            resetDeviceLogsForm, resetDeviceMessageForm, resetCloudVideoForm,
            viewUserDetail, viewCloudStorage, viewDeviceShadow, closeDeviceShadowDialog
        }
    }
}
</script>

<style scoped>
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
}

::v-deep(.el-card__body) {
    padding: 12px 12px 16px;
}

.detail-info {
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.detail-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;
}

.detail-row:last-child {
    border-bottom: none;
}

.detail-item {
    flex: 1;
    display: flex;
    min-height: 40px;
    line-height: 40px;
}

.detail-label {
    width: 180px;
    padding: 0 12px;
    background: #fafafa;
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    border-right: 1px solid #ebeef5;
    flex-shrink: 0;
}

.detail-value {
    flex: 1;
    padding: 0 12px;
    font-size: 14px;
    color: #303133;
    word-break: break-all;
}

.detail-item+.detail-item {
    border-left: 1px solid #ebeef5;
}

.video-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
}

.video-card {
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.3s ease;
}

.video-card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.video-placeholder {
    width: 100%;
    aspect-ratio: 320 / 180;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.video-placeholder ::v-deep(.el-image) {
    display: block;
    width: 100%;
    height: 100%;
}

.video-placeholder ::v-deep(.el-image__inner) {
    width: 100%;
    height: 100%;
}

.device-msg-histogram {
    margin-bottom: 16px;
    padding: 12px 14px;
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.device-msg-histogram__toolbar {
    margin-bottom: 6px;
    font-size: 12px;
}

.device-msg-histogram__toolbar-main {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 16px;
    width: 100%;
}

.device-msg-histogram__hits {
    font-weight: 600;
    color: #303133;
    font-size: 12px;
}

.device-msg-histogram__range {
    flex: 1;
    text-align: center;
    color: #606266;
    font-size: 11px;
    min-width: 120px;
}

.device-msg-histogram__granularity {
    color: #909399;
    font-size: 11px;
}

.device-msg-histogram__link-sm {
    font-size: 12px;
}

.device-msg-histogram__link-sm :deep(.el-link--inner) {
    font-size: 12px;
}

.device-msg-histogram__chart-wrap {
    min-height: 162px;
}

.device-msg-histogram__chart {
    width: 100%;
    height: 160px;
}

.video-info {
    padding: 8px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    font-size: 12px;
}

.info-row:last-child {
    margin-bottom: 0;
}

.info-row .label {
    color: #606266;
    font-weight: 500;
    min-width: 60px;
}

.info-row .value {
    color: #303133;
    text-align: right;
    flex: 1;
    margin-left: 8px;
    word-break: break-all;
}
</style>

<style>
.json-pre {
    background-color: #f5f5f5;
    padding: 12px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 1.4;
    max-height: 300px;
    overflow-y: auto;
    margin: 0;
}
</style>
